import React from "react";
import {
  PenTool, Megaphone, Code2, Server, MessageCircle, Search,
  Sparkles, Palette, Rocket, Globe, BarChart3, Layers, Camera, Mail,
} from "lucide-react";

const map = {
  PenTool, Megaphone, Code2, Server, MessageCircle, Search,
  Sparkles, Palette, Rocket, Globe, BarChart3, Layers, Camera, Mail,
};

export const iconNames = Object.keys(map);

export const ServiceIcon = ({ name = "Sparkles", size = 28, className = "" }) => {
  const Comp = map[name] || Sparkles;
  return <Comp size={size} className={className} />;
};

export default ServiceIcon;
